<template>
    <div>
        <div>
            <div class="flex justify-between">
                <span v-for="stage in stages" class="uppercase text-xs font-medium" :key="stage.titleStage">
                    {{ stage.titleStage }}
                </span>
            </div>
        </div>
        <div class="relative mt-4 px-12">
            <div class="w-full bg-gray-300 h-1 relative">
                <div v-for="(stage, i) in stages" :key="stage.titleStage + i"
                    class="absolute w-4 h-4 rounded-full z-10"
                    style="top: -6px"
                    :class="`${stage.selected ? 'bg-gray-900' : stage.completed ? 'bg-green-500': 'bg-gray-300'}`"
                    :style="{ left: positionsDots(i) }"
                />
                <div
                    class="w-full bg-green-500 h-1 absolute transition-all linear duration-500"
                    :style="sliderWidth"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Slider',
    props: {
        stages: { type: Array, default: () => [] },
    },
    methods: {
        positionsDots(index){
            return `${this.stages[index].percentage}`
        },
    },
    computed: {
        sliderWidth() {
            const stage = this.stages.find((stage) => stage.selected)
            return {
                width: stage ? stage.percentage : '0%'
            };
        },
    }
}
</script>
